import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { MuiChipsInput } from 'mui-chips-input';
import { Controller } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUsersName } from 'services/users-service';
import { useAuthTenant } from 'store/auth';

export const Detalhes = ({ handleNext, register, control, handleSubmit, errors, getValues, id }) => {
  const selectedTenant = useSelector(useAuthTenant);
  const navigate = useNavigate();
  const onSubmit = () => {
    handleNext();
  };

  const { data: users } = useQuery(['getUsers'], async () => {
    const result = await getUsersName(selectedTenant.slug);
    return result?.data.length > 0 ? result?.data : [];
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row justifyContent="center">
        <Column xs={12} md={6} className="d-flex">
          <div data-tour="system-name" style={{ width: '100%' }}>
            <CustomTextField
              {...register('name', { required: 'Nome é obrigatório' })}
              label="Nome"
            autoFocus
            error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
            disabled={!!id}
          />
          </div>
        </Column>
        <Column xs={12} md={6} className="d-flex">
          <div data-tour="system-criticity" style={{ width: '100%' }}>
            <Controller
              control={control}
              rules={{
              validate: () => {
                return getValues('criticity') !== '';
              },
              required: 'Criticidade é obrigatório',
            }}
            name="criticity"
            render={({ field: { onChange, value } }) => (
              <FormControl fullWidth sx={{ marginBottom: '20px' }} error={errors?.criticity ? true : false}>
                <InputLabel id="criticity-label" shrink>
                  Criticidade
                </InputLabel>
                <Select
                  labelId="criticity-label"
                  id="criticity"
                  value={value}
                  notched
                  label="Criticidade"
                  onChange={onChange}
                  sx={{
                    '.MuiSelect-select': {
                      padding: '13px 14px',
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) return 'Selecione uma criticidade';
                    
                    const getCriticityColor = (level) => {
                      const colors = {
                        '1': '#22c55e', // Verde
                        '2': '#84cc16', // Verde claro
                        '3': '#eab308', // Amarelo
                        '4': '#f97316', // Laranja
                        '5': '#ef4444'  // Vermelho
                      };
                      return colors[level] || '#6b7280';
                    };
                    
                    const getCriticityLabel = (level) => {
                          const labels = {
                            '1': '1 - Muito Baixa',
                            '2': '2 - Baixa',
                            '3': '3 - Média',
                            '4': '4 - Alta',
                            '5': '5 - Muito Alta'
                          };
                          return labels[level] || level;
                        };
                    
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div 
                          style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: getCriticityColor(selected),
                            border: '1px solid rgba(0,0,0,0.1)'
                          }}
                        />
                        <span>{getCriticityLabel(selected)}</span>
                      </div>
                    );
                  }}
                >
                  <MenuItem value="" key={-1}>
                    Selecione uma criticidade
                  </MenuItem>
                  {['1', '2', '3', '4', '5'].map((item, index) => {
                    const getCriticityColor = (level) => {
                      const colors = {
                        '1': '#22c55e', // Verde
                        '2': '#84cc16', // Verde claro
                        '3': '#eab308', // Amarelo
                        '4': '#f97316', // Laranja
                        '5': '#ef4444'  // Vermelho
                      };
                      return colors[level] || '#6b7280';
                    };
                    
                    const getCriticityLabel = (level) => {
                        const labels = {
                          '1': '1 - Muito Baixa',
                          '2': '2 - Baixa',
                          '3': '3 - Média',
                          '4': '4 - Alta',
                          '5': '5 - Muito Alta'
                        };
                        return labels[level] || level;
                      };
                    
                    return (
                      <MenuItem value={item} key={index}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div 
                            style={{
                              width: '12px',
                              height: '12px',
                              borderRadius: '50%',
                              backgroundColor: getCriticityColor(item),
                              border: '1px solid rgba(0,0,0,0.1)'
                            }}
                          />
                          <span>{getCriticityLabel(item)}</span>
                        </div>
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{errors?.criticity ? errors.criticity.message : ''}</FormHelperText>
              </FormControl>
            )}
          />
          </div>
        </Column>
      </Row>
      <Row>
        <Column xs={12} md={4} className="d-flex">
          <div data-tour="system-user" style={{ width: '100%' }}>
            <Controller
              control={control}
              rules={{
              validate: () => {
                return getValues('user') !== '';
              },
              required: 'Responsável é obrigatório',
            }}
            name="user"
            render={({ field: { onChange, value } }) => (
              <FormControl fullWidth sx={{ marginBottom: '20px' }} error={errors?.user ? true : false}>
                <InputLabel id="user-label" shrink>
                  Responsável
                </InputLabel>
                <Select
                  labelId="user-label"
                  id="user"
                  value={value}
                  notched
                  label="Responsável"
                  onChange={onChange}
                  sx={{
                    '.MuiSelect-select': {
                      padding: '13px 14px',
                    },
                  }}
                >
                  <MenuItem value="" key={-1}>
                    Selecione um responsável
                  </MenuItem>
                  {users
                    ?.map(user => user.name)
                    .map((item, index) => (
                      <MenuItem value={item} key={`user-${index}`}>
                        {item}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{errors?.user ? errors.user.message : ''}</FormHelperText>
              </FormControl>
            )}
          />
          </div>
        </Column>
        <Column xs={12} md={4} className="d-flex">
          <FormControl fullWidth sx={{ margin: '0 auto 23px' }} data-tour="system-tags">
            <Controller
              control={control}
              name="tags"
              render={({ field: { onChange, value } }) => (
                <MuiChipsInput
                  label="Tags"
                  value={value}
                  onChange={onChange}
                  InputLabelProps={{ shrink: true }}
                  placeholder="Digite e aperte enter"
                  renderChip={(Component, props) => {
                    return (
                      <Component
                        {...props}
                        variant="outlined"
                        color="primary"
                        sx={{
                          width: 'fit-content',
                        }}
                      />
                    );
                  }}
                  sx={{
                    '.MuiInputBase-root': {
                      padding: '6px 14px',
                    },
                    '& .MuiButtonBase-root.MuiChip-root.MuiChip-filled': {
                      width: 'fit-content',
                    },
                    '& .MuiButtonBase-root.MuiIconButton-root': {
                      width: 'fit-content',
                      marginTop: '0px',
                    },
                  }}
                />
              )}
            ></Controller>
          </FormControl>
        </Column>
        <Column xs={12} md={4} className="d-flex">
          <div data-tour="system-database" style={{ width: '100%' }}>
            <CustomTextField
              {...register('dataBase')}
              label="Banco de dados"
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
      </Row>
      <Row>
        <Column xs={12} className="d-flex" data-tour="system-checkboxes">
          <Controller
            control={control}
            name="saas"
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                value={value}
                control={<Checkbox checked={value} onChange={onChange} name="saas" />}
                label="SaaS"
                sx={{ marginLeft: 0, marginBottom: '16px' }}
              />
            )}
          />
          <Controller
            control={control}
            name="developedInHouse"
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                value={value}
                control={<Checkbox checked={value} onChange={onChange} name="developedInHouse" />}
                label="Desenvolvido internamente"
                sx={{
                  marginLeft: 0,
                  marginBottom: '16px',
                  '& .MuiTypography-root': {
                    whiteSpace: 'nowrap',
                  },
                }}
              />
            )}
          />
        </Column>
      </Row>
      <Row>
        <Column>
          <div data-tour="system-description" style={{ width: '100%' }}>
            <TextField
              {...register('description', {
                required: 'Descrição é obrigatório',
              })}
              label="Descrição"
            multiline
            rows={4}
            error={errors?.description ? true : false}
            helperText={errors?.description ? errors.description.message : null}
            sx={{ margin: '0 auto 24px', width: '100%' }}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
      </Row>
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} md={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <div data-tour="form-actions" style={{ display: 'flex', gap: '8px', width: '100%', justifyContent: 'flex-end' }}>
            <ButtonForm secondary id="cancel" label="cancelar" onClick={() => navigate('/systems')}></ButtonForm>
            <ButtonForm label="Salvar" type="submit" />
          </div>
        </Column>
      </Row>
    </form>
  );
};
